/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetUsersProfileBalanceQueryResponse, GetUsersProfileBalance400 } from "../entities/GetUsersProfileBalance";

function getGetUsersProfileBalanceUrl() {
  const res = { method: 'GET', url: `/users/profile/balance` as const }  
  return res
}

/**
 * @description Получение баланса пользователя
 * @summary Баланс пользователя
 * {@link /users/profile/balance}
 */
export async function getUsersProfileBalance(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetUsersProfileBalanceQueryResponse, ResponseErrorConfig<GetUsersProfileBalance400>, unknown>({ method : "GET", url : getGetUsersProfileBalanceUrl().url.toString(), ... requestConfig })  
  return res.data
}